import LikeOutlineIcon from 'public/icons/icn-favorite-outline.svg';
import LikeOutlineLgIcon from 'public/icons/icn-favorite-outline-lg.svg';
import LikeFilledIcon from 'public/icons/icn-like-filled.svg';
import LikeFilledLgIcon from 'public/icons/icn-like-filled-lg.svg';

export interface LikeIconProps {
  liked?: boolean;
  large?: boolean;
}

export const LikeIcon = ({ liked, large }: LikeIconProps): JSX.Element => {
  const className = liked ? 'like-icon svg-fill-primary' : 'like-icon';

  const Icon = liked ? (large ? LikeFilledLgIcon : LikeFilledIcon) : large ? LikeOutlineLgIcon : LikeOutlineIcon;

  return <Icon className={className} style={{ flexShrink: 0, display: 'block' }} />;
};
